
// import React from "react";

// const WebViewRideDetails = ({ booking }) => {
//   if (!booking) return <p style={styles.loading}>Loading ride details...</p>;

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.title}>Ride Summary</h2>

//       <div style={styles.card}>
//         <Detail label="Name" value={booking.name} />
//         <Detail label="Email" value={booking.email} />
//         <Detail label="Contact" value={booking.contactNumber} />
//         <Detail label="Pickup" value={booking.homeAddress} />
//         <Detail label="Drop" value={booking.officeAddress} />
//         <Detail label="Occupation" value={booking.occupation} />
//         <Detail label="Gender" value={booking.gender} />
//         <Detail label="Date" value={formatDate(booking.fromDate)} />
//         <Detail label="Arrival Time" value={booking.officeArrivalTime} />
//         <Detail label="Departure Time" value={booking.officeDepartureTime} />
//         <Detail label="Passengers" value={booking.passengerCount} />
//         <Detail label="Distance" value={`${booking.distance} km`} />
//         <Detail label="Fare" value={`₹${booking.fare}`} />
//       </div>

//       {/* <button
//         style={styles.payButton}
//         onClick={() =>
//           window.location.href = `/pay?rideBookingId=${booking.bookingId}`
//         }
//       >
//         Pay ₹{booking.fare}
//       </button> */}
//     </div>
//   );
// };

// const Detail = ({ label, value }) => (
//   <div style={styles.detailRow}>
//     <span style={styles.label}>{label}</span>
//     <span style={styles.value}>{value}</span>
//   </div>
// );

// const formatDate = (isoDate) => {
//   const date = new Date(isoDate);
//   return date.toLocaleDateString("en-IN", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//   });
// };

// const styles = {
//   container: {
//     padding: "20px",
//     backgroundColor: "#FAFAFA",
//     fontFamily: "'Roboto', 'Segoe UI', sans-serif",
//     minHeight: "100vh",
//   },
//   title: {
//     textAlign: "center",
//     fontSize: "22px",
//     fontWeight: "600",
//     marginBottom: "20px",
//     color: "#2c3e50",
//   },
//   card: {
//     backgroundColor: "#ffffff",
//     borderRadius: "16px",
//     padding: "20px",
//     boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
//     marginBottom: "30px",
//   },
//   detailRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     padding: "10px 0",
//     borderBottom: "1px solid #f0f0f0",
//   },
//   label: {
//     fontWeight: "500",
//     color: "#666",
//     fontSize: "15px",
//   },
//   value: {
//     color: "#111",
//     fontSize: "15px",
//     maxWidth: "50%",
//     textAlign: "right",
//     wordBreak: "break-word",
//   },
//   payButton: {
//     width: "100%",
//     padding: "14px",
//     backgroundColor: "#1e88e5",
//     color: "#fff",
//     border: "none",
//     borderRadius: "12px",
//     fontSize: "17px",
//     fontWeight: "600",
//     cursor: "pointer",
//     boxShadow: "0 4px 12px rgba(30, 136, 229, 0.3)",
//     transition: "background-color 0.3s ease",
//   },
//   loading: {
//     textAlign: "center",
//     marginTop: "40px",
//     fontSize: "18px",
//     color: "#999",
//   },
// };

// export default WebViewRideDetails;

import React from "react";

const WebViewRideDetails = ({ booking }) => {
  if (!booking) return <p style={styles.loading}>Loading ride details...</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Ride Summary</h2>

      <div style={styles.card}>
        <Detail label="Name" value={booking.name} />
        <Detail label="Email" value={booking.email} />
        <Detail label="Contact" value={booking.contactNumber} />
        <Detail label="Pickup" value={booking.homeAddress} />
        <Detail label="Drop" value={booking.officeAddress} />
        <Detail label="Occupation" value={booking.occupation} />
        <Detail label="Gender" value={booking.gender} />
        <Detail label="Date" value={formatDate(booking.fromDate)} />
        <Detail label="Arrival Time" value={booking.officeArrivalTime} />
        <Detail label="Departure Time" value={booking.officeDepartureTime} />
        <Detail label="Passengers" value={booking.passengerCount} />
        <Detail label="Distance" value={`${booking.distance} km`} />
        <Detail label="Fare" value={`₹${booking.fare}`} />
      </div>
    </div>
  );
};

const Detail = ({ label, value }) => (
  <div style={styles.detailRow}>
    <span style={styles.label}>{label}</span>
    <span style={styles.value}>{value}</span>
  </div>
);

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const styles = {
  container: {
    padding: "16px",
    backgroundColor: "#FAFAFA",
    fontFamily: "'Roboto', 'Segoe UI', sans-serif",
    // ❌ Removed: minHeight: "100vh" — was forcing full-viewport height
  },
  title: {
    textAlign: "center",
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "16px",          // ✅ reduced from 20px
    color: "#2c3e50",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "20px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    // ❌ Removed: marginBottom: "30px" — extra space before Pay button
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #f0f0f0",
  },
  label: {
    fontWeight: "500",
    color: "#666",
    fontSize: "15px",
  },
  value: {
    color: "#111",
    fontSize: "15px",
    maxWidth: "50%",
    textAlign: "right",
    wordBreak: "break-word",
  },
  loading: {
    textAlign: "center",
    marginTop: "40px",
    fontSize: "18px",
    color: "#999",
  },
};

export default WebViewRideDetails;